module.exports = __webpack_public_path__ + "static/LogoDesignServices_Thumbnail-75ebde51f789b5fca658f02f97325548.jpg";